export const UPDATE_STATES = "UPDATE_STATES";

export const updateStates = (value) => ({
  type: UPDATE_STATES,
  value,
});
